import React, { useContext, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { UI, ScreenSize } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";

export interface ConfigurationRow {
  key: string;
  value: string | null;
}

interface ConfigurationListProps {
  configurations: ConfigurationRow[];
}

const ConfigurationListBase = (props: ConfigurationListProps) => {
  const { uiStore } = useContext(RootStoreContext);

  const renderItem = useCallback((row: ConfigurationRow, screenSize: ScreenSize) => {
    let listRows: React.ReactElement[] = [];

    const renderValue = () => {
      if (row.value === "true") {
        return <input type="checkbox" checked disabled />;
      }
      if (row.value === "false") {
        return <input type="checkbox" disabled />;
      }
      return row.value ?? "—";
    };

    switch (screenSize) {
      case ScreenSize.DESKTOP:
        listRows = [
          <UI.List.Row key={"r-1"}>
            <UI.List.Cell key={"c-1"} colspan={1} value={row.key} />
            <UI.List.Cell key={"c-2"} colspan={1} value={renderValue()} />
          </UI.List.Row>,
        ];
        break;

      case ScreenSize.MOBILE:
        listRows = [
          <UI.List.Row key={"r-1"}>
            <UI.List.Cell key={"c-1"} colspan={1} value={row.key} />
            <UI.List.Cell key={"c-2"} colspan={1} value={renderValue()} />
          </UI.List.Row>,
        ];
        break;
    }

    return <UI.List.Item key={`${row.key}-${row.value ?? ""}`} screenSize={screenSize} rows={listRows} />;
  }, []);

  const renderHeader = useCallback((screenSize: ScreenSize) => {
    let headerRows: React.ReactElement[] = [];

    switch (screenSize) {
      case ScreenSize.DESKTOP:
        headerRows = [
          <UI.List.Row key={"row-1"}>
            <UI.List.Cell key={"c-1"} colspan={1} value={"Key"} />
            <UI.List.Cell key={"c-2"} colspan={1} value={"Wert"} />
          </UI.List.Row>,
        ];
        break;
      case ScreenSize.MOBILE:
        headerRows = [
          <UI.List.Row key={"row-1"}>
            <UI.List.Cell key={"c-1"} colspan={1} value={"Key"} />
            <UI.List.Cell key={"c-2"} colspan={1} value={"Wert"} />
          </UI.List.Row>,
        ];
        break;
    }

    return <UI.List.Header rows={headerRows} sticky={true} top={130} />;
  }, []);

  return (
    <UI.List.BasicList
      screenSize={uiStore.isMobile ? ScreenSize.MOBILE : ScreenSize.DESKTOP}
      items={props.configurations}
      renderItem={renderItem}
      renderHeader={renderHeader}
    />
  );
};

export const ConfigurationList = observer(ConfigurationListBase);
